import { memo } from "react";
import RadioGroup from "@/pages/capture/components/RadioGroup";
import { literals } from "@/constants/literals";

export type PackagingProps = {
  changeOwnPackaging: () => void;
  changeCorrectPackaging: () => void;
  changeDamagedPackaging: () => void;
  ownPackaging?: boolean;
  correctPackaging?: boolean;
  damagedPackaging?: boolean;
};

const Packaging = ({
  ownPackaging,
  changeOwnPackaging,
  correctPackaging,
  changeCorrectPackaging,
  damagedPackaging,
  changeDamagedPackaging,
}: PackagingProps) => {
  return (
    <div className="w-full px-4 pt-4 md:flex md:flex-col items-center md:px-[calc((100%-492px)/2)] md:min-h-[270px]">
      <div className="max-md:w-full mb-6 md:mb-1">
        <RadioGroup
          label={literals.ownPackaging}
          selected={ownPackaging}
          onChange={changeOwnPackaging}
        />
      </div>
      <div className="max-md:w-full mb-6 md:mb-1">
        <RadioGroup
          label={literals.correctPackaging}
          selected={correctPackaging}
          onChange={changeCorrectPackaging}
        />
      </div>
      <div className="max-md:w-full mb-6 md:mb-4">
        <RadioGroup
          label={literals.damagedPackaging}
          selected={damagedPackaging}
          onChange={changeDamagedPackaging}
        />
      </div>
    </div>
  );
};

export default memo(Packaging);
